(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /**
   * One announcement at a time, wrapping in both directions.
   *
   * This used Swiper. The bar lives in the header group, so that put a 151 KB
   * carousel library on every page of the store to slide two lines of text. What
   * Swiper was giving us here was a translate and an interval; everything else in
   * its config (loop, slidesPerView: 1, spaceBetween: 0) was describing a plain
   * one-up track.
   *
   * Two things are better than before rather than merely equal:
   * - Off-screen announcements are `inert`, so their links leave the tab order
   *   and screen readers only meet the one on show. Under `overflow: hidden`
   *   those links stayed focusable, and focusing one scrolled the container.
   * - The timer stops while the tab is hidden, so a backgrounded tab is not
   *   paying for a rotation nobody is watching.
   *
   * Dropped on purpose: Swiper's keyboard module, which bound arrow keys at the
   * document. The arrows are buttons and reach the keyboard on their own; taking
   * over Left/Right for the whole page to serve a text ticker was too much.
   */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-announcement-track]');
      this.items = Array.from(this.querySelectorAll('[data-announcement-item]'));
      if (!this.track || this.items.length <= 1) return;

      this.index = 0;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.delay = (parseInt(this.dataset.speed, 10) || 6) * 1000;

      this.onPrevious = () => this.step(-1, true);
      this.onNext = () => this.step(1, true);
      this.previous = this.querySelector('.announcement-bar__arrow--prev');
      this.next = this.querySelector('.announcement-bar__arrow--next');
      if (this.previous) this.previous.addEventListener('click', this.onPrevious);
      if (this.next) this.next.addEventListener('click', this.onNext);

      // Pointer and focus both pause: someone reading an announcement, or tabbing
      // to its link, must not have it slide away mid-sentence.
      this.onPause = () => this.stop();
      this.onResume = () => this.start();
      this.addEventListener('pointerenter', this.onPause);
      this.addEventListener('pointerleave', this.onResume);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onResume);

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.show(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.previous) this.previous.removeEventListener('click', this.onPrevious);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    get autoplays() {
      return this.dataset.autoplay === 'true' && !this.reduceMotion.matches;
    }

    start() {
      this.stop();
      if (!this.autoplays || document.hidden) return;
      this.timer = window.setInterval(() => this.step(1), this.delay);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    /** `restart` is for a press: the next slide gets its full time on screen. */
    step(delta, restart) {
      const total = this.items.length;
      this.show((this.index + delta + total) % total);
      if (restart) this.start();
    }

    show(index) {
      this.index = index;

      // The track moves the other way in a right-to-left market, so the sign
      // comes from the computed direction rather than being assumed.
      const rtl = window.getComputedStyle(this).direction === 'rtl';
      this.track.style.transform = 'translateX(' + (rtl ? 1 : -1) * index * 100 + '%)';

      this.items.forEach((item, i) => item.toggleAttribute('inert', i !== index));
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  /*
   * Share without a third party. `navigator.share` where the browser has it —
   * that is the sheet a phone reader expects — and the clipboard everywhere
   * else. Both are behind a user gesture, which is what they require.
   *
   * The button ships as "Copy link" and upgrades to "Share" only once the API
   * is known to exist, so a browser without it never offers something that
   * silently does nothing.
   */
  class ShareArticle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-share-button]');
      this.labelEl = this.querySelector('[data-share-label]');
      if (!this.button) return;

      this.canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
      if (this.canShare && this.labelEl && this.dataset.labelShare) {
        this.labelEl.textContent = this.dataset.labelShare;
      }

      this.button.addEventListener('click', () => this.onClick());
    }

    async onClick() {
      const url = this.dataset.url;
      const title = this.dataset.title;
      if (!url) return;

      if (this.canShare) {
        try {
          await navigator.share({ title: title, url: url });
          return;
        } catch (error) {
          // A dismissed share sheet is not a failure; fall through to copying.
          if (error && error.name === 'AbortError') return;
        }
      }

      try {
        await navigator.clipboard.writeText(url);
        this.confirm();
      } catch (error) {
        // Clipboard refused (insecure context, or permission denied). Select the
        // URL so the reader can copy it themselves rather than see nothing happen.
        window.prompt(this.dataset.title || '', url);
      }
    }

    confirm() {
      if (!this.labelEl || !this.dataset.labelCopied) return;
      const original = this.labelEl.textContent;
      this.labelEl.textContent = this.dataset.labelCopied;
      this.button.setAttribute('data-copied', 'true');
      window.setTimeout(() => {
        this.labelEl.textContent = original;
        this.button.removeAttribute('data-copied');
      }, 2000);
    }
  }

  if (!customElements.get('share-article')) {
    customElements.define('share-article', ShareArticle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-selling-yarns"] && !Shopify.designMode) return;
  try {
    
  class BestSellingYarns extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.swiper');
      this.slides = this.querySelectorAll('.swiper-slide');
      if (!this.swiperEl || this.slides.length === 0) return;

      this.waitFor(() => window.Swiper, () => this.init());
    }

    init() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayEnabled = this.dataset.autoplay === 'true' && !reduceMotion;
      const speed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      const gap = parseInt(this.dataset.gap, 10) || 16;
      const desktopSlides = parseFloat(this.dataset.slidesDesktop) || 4;
      const tabletSlides = parseFloat(this.dataset.slidesTablet) || 2.2;
      const mobileSlides = parseFloat(this.dataset.slidesMobile) || 1.2;
      const paginationEl = this.querySelector('.bsy__pagination');

      this.swiper = new window.Swiper(this.swiperEl, {
        slidesPerView: mobileSlides,
        spaceBetween: gap,
        speed: 500,
        loop: this.dataset.loop === 'true' && this.slides.length > desktopSlides,
        a11y: { enabled: true },
        keyboard: { enabled: true },
        autoplay: autoplayEnabled
          ? { delay: speed, pauseOnMouseEnter: true, disableOnInteraction: false }
          : false,
        navigation: {
          prevEl: this.querySelector('.bsy__arrow--prev'),
          nextEl: this.querySelector('.bsy__arrow--next'),
          disabledClass: 'swiper-button-disabled'
        },
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        breakpoints: {
          750: { slidesPerView: tabletSlides },
          990: { slidesPerView: desktopSlides }
        }
      });
    }

    waitFor(check, callback, attempts) {
      attempts = attempts || 0;
      if (check()) return callback();
      if (attempts > 100) return;
      setTimeout(() => this.waitFor(check, callback, attempts + 1), 50);
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy(true, true);
    }
  }

  if (!customElements.get('best-selling-yarns')) {
    customElements.define('best-selling-yarns', BestSellingYarns);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.openButton = this.querySelector('[data-collection-filter-open]');
      this.dialog = this.querySelector('[data-collection-filter-dialog]');
      this.realtime = this.dataset.realtimeFiltering === 'true';
      this.events = new AbortController();
      const eventOptions = { signal: this.events.signal };

      this.querySelectorAll('[data-filter-options-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const list = document.getElementById(button.getAttribute('aria-controls'));
          if (!list) return;

          const expanded = button.getAttribute('aria-expanded') !== 'true';
          list.querySelectorAll('[data-filter-overflow]').forEach((option) => {
            option.hidden = !expanded;
          });

          button.setAttribute('aria-expanded', String(expanded));
          const label = button.querySelector('[data-filter-options-toggle-label]');
          if (label) label.textContent = expanded ? button.dataset.hideLabel : button.dataset.showLabel;
        }, eventOptions);
      });

      // Before the early return below: sorting has to work on a collection
      // with no filters at all, where there is no dialog to set up.
      this.querySelectorAll('[data-collection-sort]').forEach((form) => {
        const select = form.querySelector('select');
        if (!select) return;

        select.addEventListener('change', () => {
          if (this.realtime) {
            this.renderFromForm(form);
          } else if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }, eventOptions);
      });

      this.querySelectorAll('.collection-filters__form').forEach((form) => {
        form.addEventListener('submit', (event) => {
          form.querySelectorAll('[data-collection-range-input]').forEach((input) => {
            if (input.value.trim() === '') input.disabled = true;
          });

          if (!this.realtime) return;
          event.preventDefault();
          this.renderFromForm(form);
        }, eventOptions);

        if (!this.realtime) return;

        form.addEventListener('change', (event) => {
          if (event.target.matches('.collection-filter__checkbox')) {
            this.scheduleForm(form, 120);
          } else if (event.target.matches('[data-collection-range-input]')) {
            this.scheduleForm(form, 250);
          }
        }, eventOptions);

        form.addEventListener('input', (event) => {
          if (event.target.matches('[data-collection-range-input]')) {
            this.scheduleForm(form, 450);
          }
        }, eventOptions);
      });

      if (this.realtime) {
        this.addEventListener('click', (event) => {
          /* Every selector here names a link that changes *this* collection's
             view — a filter removed, a page turned, everything cleared. The back
             link to the fibre index is deliberately absent: it goes to another
             page, and intercepting it produced exactly the failure below. */
          const link = event.target.closest(
            '.collection-filter__clear, .collection-active-filters__item, .collection-active-filters__clear-all, .collection-filters__desktop-head a, .collection-page__pagination a'
          );
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

          /* A link leaving this collection is a navigation, so let the browser
             do it. Without this guard, `renderUrl` asks the destination for
             *this* section, and a page template answering with the collection
             section cannot paginate `collection.products` — Shopify prints
             "Array 'collection.products' is not paginateable" into the page,
             the URL has already been pushed, and the shopper is left on a
             half-replaced page that never navigated. That is what a stray
             selector in the list above did once; the guard makes the next one
             harmless. */
          const url = new URL(link.href, window.location.origin);
          const base = this.dataset.collectionUrl;
          if (url.origin !== window.location.origin) return;
          if (base && url.pathname !== base && url.pathname.indexOf(base + '/') !== 0) return;

          event.preventDefault();
          this.renderUrl(url);
        }, eventOptions);

        window.addEventListener('popstate', () => {
          this.renderUrl(new URL(window.location.href), { updateHistory: false });
        }, eventOptions);
      }

      if (!this.openButton || !this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.openButton.addEventListener('click', () => {
        this.dialog.showModal();
        this.openButton.setAttribute('aria-expanded', 'true');
      }, eventOptions);

      this.dialog.querySelectorAll('[data-collection-filter-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close(), eventOptions);
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      }, eventOptions);

      this.dialog.addEventListener('close', () => {
        this.openButton.setAttribute('aria-expanded', 'false');
        this.openButton.focus();
      }, eventOptions);

      window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
        if (event.matches && this.dialog.open) this.dialog.close();
      }, eventOptions);
    }

    disconnectedCallback() {
      this.events?.abort();
      window.clearTimeout(this.formTimer);
    }

    scheduleForm(form, delay) {
      window.clearTimeout(this.formTimer);
      this.formTimer = window.setTimeout(() => this.renderFromForm(form), delay);
    }

    renderFromForm(form) {
      const url = new URL(form.action, window.location.origin);
      const formData = new FormData(form);
      form.querySelectorAll('[data-collection-range-input]').forEach((input) => {
        if (input.value.trim() === '') formData.delete(input.name);
      });
      const params = new URLSearchParams(formData);
      url.search = params.toString();
      this.renderUrl(url);
    }

    async renderUrl(browserUrl, options = {}) {
      const updateHistory = options.updateHistory !== false;
      const requestUrl = new URL(browserUrl);
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);

      CollectionFilters.requestController?.abort();
      const controller = new AbortController();
      CollectionFilters.requestController = controller;

      const restoreDialog = Boolean(this.dialog?.open);
      const restoreFocusId = document.activeElement?.id;
      const expandedOptionLists = new Set(
        Array.from(this.querySelectorAll('[data-filter-options-toggle][aria-expanded="true"]')).map((button) =>
          button.getAttribute('aria-controls')
        )
      );
      this.dataset.loading = 'true';
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(requestUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const replacement = documentFragment.querySelector('collection-filters');
        if (!replacement) throw new Error('Collection section was missing from the response.');

        browserUrl.searchParams.delete('section_id');
        if (updateHistory) window.history.pushState({}, '', browserUrl);

        this.replaceWith(replacement);

        window.requestAnimationFrame(() => {
          replacement.querySelectorAll('[data-filter-options-toggle]').forEach((button) => {
            if (expandedOptionLists.has(button.getAttribute('aria-controls'))) button.click();
          });

          if (restoreDialog) {
            const nextDialog = replacement.querySelector('[data-collection-filter-dialog]');
            if (nextDialog && typeof nextDialog.showModal === 'function') {
              nextDialog.showModal();
              replacement.querySelector('[data-collection-filter-open]')?.setAttribute('aria-expanded', 'true');
            }
          }

          if (restoreFocusId) {
            document.getElementById(restoreFocusId)?.focus({ preventScroll: true });
          }
        });
      } catch (error) {
        if (error.name === 'AbortError') return;
        browserUrl.searchParams.delete('section_id');
        window.location.assign(browserUrl);
      } finally {
        if (CollectionFilters.requestController === controller && this.isConnected) {
          delete this.dataset.loading;
          this.removeAttribute('aria-busy');
        }
      }
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-bar"] && !Shopify.designMode) return;
  try {
    
  /**
   * Submits the country/language form as soon as the shopper picks an option, so
   * they don't have to find a separate button. The button stays in the markup for
   * anyone without JavaScript — it's hidden until it takes focus.
   */
  class LocalizationSelect extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const select = this.querySelector('[data-localization-select]');
      if (!select) return;

      select.addEventListener('change', () => {
        select.form?.submit();
      });
    }
  }

  if (!customElements.get('localization-select')) {
    customElements.define('localization-select', LocalizationSelect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /**
   * Keeps the collapsible footer columns in step with the viewport: open (and
   * un-toggleable) from tablet up, collapsed on phones. The markup ships open so
   * the links are there without JavaScript.
   */
  class FooterColumns extends HTMLElement {
    connectedCallback() {
      // connectedCallback can fire more than once (re-parenting, theme editor
      // section reloads, hot reload).
      if (this.initialized) return;
      this.initialized = true;

      if (this.dataset.accordion !== 'true') return;

      this.panels = Array.from(this.querySelectorAll('.ftr__details'));
      if (!this.panels.length) return;

      this.wide = window.matchMedia('(min-width: 750px)');
      this.sync();
      this.wide.addEventListener('change', () => this.sync());
    }

    sync() {
      const open = this.wide.matches;
      this.panels.forEach((panel) => {
        panel.open = open;
      });
    }
  }

  if (!customElements.get('footer-columns')) {
    customElements.define('footer-columns', FooterColumns);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      // connectedCallback can fire more than once (re-parenting, theme editor
      // section reloads, hot reload). Without this guard the listeners stack up
      // and a single click opens then immediately closes a dropdown.
      if (this.initialized) return;
      this.initialized = true;

      this.drawerToggle = this.querySelector('[data-menu-drawer-toggle]');
      this.drawer = this.querySelector('[data-nav-drawer]');
      // Dropdowns only apply to the inline desktop nav; the drawer uses <details>
      this.items = Array.from(this.querySelectorAll('.header__nav--desktop .header__nav-item--has-children'));
      this.hoverCapable = window.matchMedia('(hover: hover)').matches;
      this.closeTimer = null;

      if (this.drawerToggle && this.drawer) {
        this.drawerToggle.addEventListener('click', () => this.drawer.showModal());

        this.drawer.querySelectorAll('[data-drawer-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.drawer.close());
        });

        // Click on the backdrop (outside the panel) closes the drawer
        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.drawer.close();
        });

        // Keep the toggle's aria-expanded in sync (Escape closes natively)
        this.drawer.addEventListener('close', () => {
          this.drawerToggle.setAttribute('aria-expanded', 'false');
          this.drawerToggle.focus();
        });
        this.drawerToggle.addEventListener('click', () => {
          this.drawerToggle.setAttribute('aria-expanded', 'true');
        });

        // Close the drawer if the viewport grows into desktop territory
        window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
          if (event.matches && this.drawer.open) this.drawer.close();
        });
      }

      this.searchToggle = this.querySelector('[data-search-toggle]');
      if (this.searchToggle) {
        this.searchToggle.addEventListener('click', () => {
          const open = this.getAttribute('data-search-open') === 'true';
          this.setAttribute('data-search-open', String(!open));
          this.searchToggle.setAttribute('aria-expanded', String(!open));
          if (!open) {
            const input = this.querySelector('.header__search-input');
            if (input) input.focus();
          }
        });
      }

      this.items.forEach((item) => this.setupItem(item));

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      });

      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.closeAll();
      });
    }

    setupItem(item) {
      const toggle = item.querySelector('[data-menu-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.classList.contains('is-open')) this.close(item);
        else this.open(item);
      });

      if (this.hoverCapable) {
        item.addEventListener('mouseenter', () => {
          clearTimeout(this.closeTimer);
          this.open(item);
        });
        item.addEventListener('mouseleave', () => {
          this.closeTimer = setTimeout(() => this.close(item), 120);
        });
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.close(item);
        });
      }
    }

    open(item) {
      this.closeAll(item);
      item.classList.add('is-open');
      const toggle = item.querySelector('[data-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      this.position(item);
    }

    close(item) {
      item.classList.remove('is-open');
      const toggle = item.querySelector('[data-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    closeAll(except) {
      this.items.forEach((item) => {
        if (item !== except) this.close(item);
      });
    }

    position(item) {
      if (!this.hoverCapable && window.innerWidth < 750) return;
      const reference = item.querySelector('[data-menu-toggle]');
      const floating = item.querySelector('.header__submenu');
      if (!window.FloatingUIDOM || !reference || !floating) return;

      const { computePosition, flip, shift, offset } = window.FloatingUIDOM;
      computePosition(reference, floating, {
        placement: 'bottom-start',
        strategy: 'absolute',
        middleware: [offset(6), flip(), shift({ padding: 12 })]
      }).then(({ x, y }) => {
        floating.style.left = x + 'px';
        floating.style.top = y + 'px';
      });
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true') return;

      this.input = this.querySelector('[data-predictive-input]');
      this.results = this.querySelector('[data-predictive-results]');
      this.url = this.dataset.url;
      this.loadingText = this.dataset.loadingText || '';
      this.debounceTimer = null;
      this.cache = {};
      this.controller = null;

      if (!this.input || !this.results) return;

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length >= 2 && this.results.innerHTML.trim()) this.open();
      });
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    onInput() {
      const query = this.input.value.trim();
      clearTimeout(this.debounceTimer);
      if (query.length < 2) {
        this.close();
        return;
      }
      this.debounceTimer = setTimeout(() => this.search(query), 250);
    }

    search(query) {
      if (this.cache[query] !== undefined) {
        this.render(this.cache[query]);
        return;
      }

      this.results.setAttribute('data-loading', '');
      this.results.setAttribute('data-loading-text', this.loadingText);
      this.open();

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const endpoint = this.url
        + '?q=' + encodeURIComponent(query)
        + '&section_id=predictive-search'
        + '&resources[type]=product,collection,query'
        + '&resources[limit]=6';

      fetch(endpoint, { signal: this.controller.signal })
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const content = doc.querySelector('[data-predictive-content]');
          const html = content ? content.innerHTML : '';
          this.cache[query] = html;
          this.render(html);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') this.close();
        });
    }

    render(html) {
      this.results.removeAttribute('data-loading');
      this.results.innerHTML = html;
      this.open();
    }

    open() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }

    onKeydown(event) {
      const options = Array.from(this.results.querySelectorAll('a'));
      if (event.key === 'Escape') {
        this.close();
        this.input.focus();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        const index = options.indexOf(document.activeElement);
        (options[index + 1] || options[0] || this.input).focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        const index = options.indexOf(document.activeElement);
        (options[index - 1] || this.input).focus();
      }
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-finder"] && !Shopify.designMode) return;
  try {
    
  class ProjectFinder extends HTMLElement {
    connectedCallback() {
      this.eventController = new AbortController();
      const signal = this.eventController.signal;
      this.cards = Array.from(this.querySelectorAll('[data-finder-card]'));
      // Each facet carries the filter parameter it writes, so this loop does not
      // have to know how many facets exist or what they are called.
      this.facets = Array.from(this.querySelectorAll('[data-finder-value]'));
      this.submitEl = this.querySelector('[data-finder-submit]');
      this.dropdowns = Array.from(this.querySelectorAll('[data-finder-dropdown]'));
      this.selectedType = '';

      // Card selection (single-select, radio behaviour)
      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectCard(card), { signal });
      });

      // Custom dropdowns (styled like the header menu)
      this.dropdowns.forEach((dd) => this.setupDropdown(dd));

      // Close the open dropdown on any click outside of it (anywhere on the page)
      document.addEventListener('click', (event) => {
        const openDropdown = this.dropdowns.find((dd) => dd.classList.contains('is-open'));
        if (openDropdown && !openDropdown.contains(event.target)) {
          this.closeDropdowns();
        }
      }, { signal });
      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.closeDropdowns();
      }, { signal });

      if (this.submitEl) {
        this.submitEl.addEventListener('click', () => this.submit(), { signal });
      }

      // Cards carousel: native scroll + snap on mobile. This adds mouse
      // drag-to-scroll so it also feels like a carousel with a pointer.
      this.carouselEl = this.querySelector('[data-finder-carousel]');
      if (this.carouselEl) this.setupDragScroll(this.carouselEl);
    }

    disconnectedCallback() {
      this.eventController?.abort();
    }

    setupDragScroll(track) {
      let down = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;

      track.addEventListener('pointerdown', (event) => {
        // Only drag when the track actually scrolls (i.e. mobile carousel)
        if (event.pointerType !== 'mouse' || track.scrollWidth <= track.clientWidth) return;
        down = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      }, { signal: this.eventController.signal });

      track.addEventListener('pointermove', (event) => {
        if (!down) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) {
          moved = true;
          track.classList.add('is-dragging');
        }
        track.scrollLeft = startScroll - delta;
      }, { signal: this.eventController.signal });

      const end = () => {
        down = false;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', end, { signal: this.eventController.signal });
      track.addEventListener('pointercancel', end, { signal: this.eventController.signal });
      track.addEventListener('pointerleave', end, { signal: this.eventController.signal });

      // Prevent a drag from also selecting a card
      track.addEventListener('click', (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, { capture: true, signal: this.eventController.signal });
    }

    setupDropdown(dd) {
      const toggle = dd.querySelector('[data-dropdown-toggle]');
      const valueEl = dd.querySelector('[data-dropdown-value]');
      const input = dd.querySelector('input[type="hidden"]');
      const options = Array.from(dd.querySelectorAll('.finder__dropdown-option'));

      toggle.addEventListener('click', () => {
        const isOpen = dd.classList.contains('is-open');
        this.closeDropdowns();
        if (!isOpen) {
          this.positionDropdown(dd, toggle);
          dd.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      }, { signal: this.eventController.signal });

      options.forEach((option) => {
        option.addEventListener('click', () => {
          input.value = option.dataset.value || '';
          valueEl.textContent = option.textContent;
          options.forEach((o) => o.setAttribute('aria-selected', o === option ? 'true' : 'false'));
          this.closeDropdowns();
          toggle.focus();
        }, { signal: this.eventController.signal });
      });

      // Keyboard: arrow navigation between options
      dd.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        if (!dd.classList.contains('is-open')) {
          toggle.click();
          if (options[0]) options[0].focus();
          return;
        }
        const index = options.indexOf(document.activeElement);
        const next = event.key === 'ArrowDown'
          ? options[index + 1] || options[0]
          : options[index - 1] || options[options.length - 1];
        if (next) next.focus();
      }, { signal: this.eventController.signal });
    }

    positionDropdown(dd, toggle) {
      const menu = dd.querySelector('[data-dropdown-menu]');
      if (!menu) return;
      const rect = toggle.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      const needed = Math.min(menu.scrollHeight, 260) + 16;
      // Open upwards only if there isn't room below but there is above
      dd.classList.toggle('is-up', spaceBelow < needed && spaceAbove > spaceBelow);
    }

    closeDropdowns() {
      this.dropdowns.forEach((dd) => {
        dd.classList.remove('is-open');
        const toggle = dd.querySelector('[data-dropdown-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    selectCard(card) {
      this.cards.forEach((c) => c.setAttribute('aria-pressed', c === card ? 'true' : 'false'));
      this.selectedType = card.dataset.typeGid || '';
    }

    submit() {
      // Every card and every facet lands in the same collection; what differs is
      // the filters. All three are metaobject-reference facets, so each value is
      // a gid — encoded, because a gid carries slashes and colons.
      const base = this.dataset.targetUrl || '/collections/all';
      const params = [];

      if (this.selectedType) {
        params.push(
          'filter.p.m.custom.pattern_project_types=' + encodeURIComponent(this.selectedType)
        );
      }

      this.facets.forEach((facet) => {
        const param = facet.dataset.filterParam;
        if (param && facet.value) {
          params.push(param + '=' + encodeURIComponent(facet.value));
        }
      });

      const url = params.length ? base + '?' + params.join('&') : base;

      // Loading state, then navigate
      this.submitEl.setAttribute('aria-busy', 'true');
      window.location.assign(url);
    }
  }

  if (!customElements.get('project-finder')) {
    customElements.define('project-finder', ProjectFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideshowSlider extends HTMLElement {
    connectedCallback() {
      this.setupMuteToggles();
      this.swiperEl = this.querySelector('.swiper');
      this.slideCount = this.querySelectorAll('.swiper-slide').length;
      if (!this.swiperEl || this.slideCount <= 1) return;
      this.waitFor(() => window.Swiper, () => this.init());
    }

    setupMuteToggles() {
      this.querySelectorAll('[data-mute-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const media = btn.closest('.slider__media');
          const video = media && media.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          btn.setAttribute('aria-pressed', String(!video.muted));
        });
      });
    }

    init() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const effect = this.dataset.effect || 'slide';
      const autoplay = this.dataset.autoplay === 'true' && !reduceMotion;

      const config = {
        effect: effect,
        loop: this.dataset.loop === 'true',
        speed: 600,
        parallax: this.dataset.parallax === 'true',
        autoHeight: this.dataset.autoHeight === 'true',
        a11y: { enabled: true },
        keyboard: { enabled: true },
        autoplay: autoplay
          ? { delay: (parseInt(this.dataset.speed, 10) || 6) * 1000, pauseOnMouseEnter: true, disableOnInteraction: false }
          : false,
        pagination: { el: this.querySelector('.slider__dots'), clickable: true },
        navigation: {
          prevEl: this.querySelector('.slider__arrow--prev'),
          nextEl: this.querySelector('.slider__arrow--next'),
          disabledClass: 'swiper-button-disabled'
        }
      };

      if (effect === 'fade') config.fadeEffect = { crossFade: true };

      this.swiper = new window.Swiper(this.swiperEl, config);
    }

    waitFor(check, callback, attempts) {
      attempts = attempts || 0;
      if (check()) return callback();
      if (attempts > 100) return;
      setTimeout(() => this.waitFor(check, callback, attempts + 1), 50);
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy(true, true);
    }
  }

  if (!customElements.get('slideshow-slider')) {
    customElements.define('slideshow-slider', SlideshowSlider);
  }

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const raw = (this.dataset.date || '').trim().replace(' ', 'T');
      this.target = new Date(raw).getTime();
      if (isNaN(this.target)) return;

      this.els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      let diff = Math.floor((this.target - Date.now()) / 1000);
      if (diff <= 0) {
        diff = 0;
        clearInterval(this.timer);
      }
      const d = Math.floor(diff / 86400);
      const h = Math.floor((diff % 86400) / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const sec = diff % 60;
      if (this.els.days) this.els.days.textContent = d;
      if (this.els.hours) this.els.hours.textContent = String(h).padStart(2, '0');
      if (this.els.minutes) this.els.minutes.textContent = String(m).padStart(2, '0');
      if (this.els.seconds) this.els.seconds.textContent = String(sec).padStart(2, '0');
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();
})();
